export const getVehicleTitle = (vehicle) => {
    if (!vehicle) {
        return null;
    }
    return `${vehicle.manufacturer} ${vehicle.modelSeries}`;
};
export const getVehicleDescription = (vehicle) => {
    if (!vehicle) {
        return null;
    }
    return vehicle.modelName;
};
export const getVehicleFullTitle = (registrationNumber, vehicle) => {
    if (!vehicle) {
        return null;
    }
    return `${registrationNumber} - ${vehicle.manufacturer} ${vehicle.modelSeries}, ${vehicle.modelName}`;
};
